import React, { Fragment } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Action } from "material-table";
import { MentorLocalizations } from "../../../Shared/sharedTypes";
import { CompletedSessionStub } from "../../../Shared/GeneratedTypes";
import MaterialTable from "../MaterialTable/MaterialTable";
import {
    Avatar,
    Menu,
    MenuItem,
    ListItemIcon,
    ListItemText,
    SvgIconProps,
    Popover,
    Theme,
    createStyles,
    Typography,
    Button,
} from "@material-ui/core";
import moment from "moment";
import { Assistant, Archive } from "@material-ui/icons";
import MenuIcon from "@material-ui/icons/Menu";
import { DateTime } from "luxon";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-around",
            overflow: "hidden",
            //backgroundColor: theme.palette.background.paper
        },
        gridList: {
            // flexWrap: 'nowrap'
        },
        popover: {
            pointerEvents: "none",
        },
        paper: {
            padding: theme.spacing(1),
        },
        large: {
            width: theme.spacing(40),
            height: theme.spacing(40),
        },
    })
);

interface propTypes {
    classes?: any;
    forwardedRef?: any;
    completedMentors: CompletedSessionStub[];
    localizations: MentorLocalizations;
    refreshTimer: number;
    refreshNow: () => void;
}

export default function CompletedMentorsList(props: propTypes) {
    const classes = useStyles();
    const { completedMentors } = props;
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    function selectOnSight(onSight: CompletedSessionStub) {
        // setActive(onSight);
    }

    let currentItem: CompletedSessionStub;

    const handleClick = (onSight: CompletedSessionStub, event: React.MouseEvent<HTMLElement>) => {
        currentItem = onSight;
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const [anchorPopOverEl, setPopOverAnchorEl] = React.useState<HTMLElement | null>(null);
    const [hoveredSession, setHoveredSession] = React.useState<CompletedSessionStub | null>(null);

    const handlePopoverOpen = (event: React.MouseEvent<HTMLElement, MouseEvent>, session: CompletedSessionStub) => {
        if (session.policyHolderImage) {
            setHoveredSession(session);
            setPopOverAnchorEl(event.currentTarget);
        }
    };

    const handlePopoverClose = () => {
        setPopOverAnchorEl(null);
    };
    const popOverOpen = Boolean(anchorPopOverEl);
    let hoveredImage = hoveredSession !== null ? hoveredSession.policyHolderImage ?? undefined : undefined;

    return (
        <Fragment>
            <MaterialTable
                title={
                    <Typography variant="h6" style={{ whiteSpace: "nowrap" }}>
                        <Archive fontSize="inherit" /> Recently Completed |{" "}
                        <Button variant="text" size="small" onClick={props.refreshNow}>
                            {"Refresh in (" + props.refreshTimer + ") sec"}
                        </Button>
                    </Typography>
                }
                localizations={props.localizations}
                options={{
                    grouping: false,
                    draggable: false,
                    search: true,
                    pageSize: 10,
                    padding: "dense",
                }}
                columns={[
                    {
                        title: props.localizations.client,
                        grouping: false,
                        cellStyle: { whiteSpace: "nowrap" },
                        customFilterAndSearch: (filter, rowData, columDef) =>
                            `${rowData.company + " " || ""} ${rowData.policyHolderFirstName} ${
                                rowData.policyHolderLastName
                            }`
                                .toLowerCase()
                                .indexOf(filter.toString().toLowerCase()) > -1,
                        render: (rowData) => (
                            <>
                                <Avatar
                                    src={rowData.policyHolderImage}
                                    variant="rounded"
                                    style={{ display: "inline-flex", verticalAlign: "middle", marginRight: 10 }}
                                    onMouseEnter={(evt) => handlePopoverOpen(evt, rowData)}
                                    onMouseLeave={handlePopoverClose}
                                ></Avatar>
                                {`${rowData.company ? rowData.company + ": " : ""} ${rowData.policyHolderFirstName} ${
                                    rowData.policyHolderLastName
                                }`}
                            </>
                        ),
                    },

                    { title: props.localizations.surveyType, field: "inspectionType" },

                    {
                        title: props.localizations.mentor,
                        cellStyle: { whiteSpace: "nowrap" },
                        customFilterAndSearch: (filter, rowData, columDef) =>
                            `${rowData.mentor?.firstName + " " || ""} ${rowData.mentor?.lastName || ""}`
                                .toLowerCase()
                                .indexOf(filter.toString().toLowerCase()) > -1,
                        render: (rowData) => (
                            <>
                                <Avatar
                                    src={rowData.mentor?.photoUrl}
                                    style={{ display: "inline-flex", verticalAlign: "middle", marginRight: 10 }}
                                    variant="rounded"
                                ></Avatar>
                                {rowData.mentor?.firstName} {rowData.mentor?.lastName}
                            </>
                        ),
                    },

                    {
                        title: props.localizations.started,
                        defaultSort: "desc",
                        field: "startedDate",
                        grouping: true,
                        type: "datetime",
                        render: (rowData) => (
                            <>
                                {rowData.startedDate
                                    ? DateTime.fromISO(rowData.startedDate as any).toLocaleString()
                                    : "-"}
                            </>
                        ),
                    },

                    {
                        title: props.localizations.ended,
                        defaultSort: "desc",
                        field: "completedDate",
                        grouping: true,
                        type: "datetime",
                        render: (rowData) => <>{DateTime.fromISO(rowData.completedDate as any).toLocaleString()}</>,
                    },
                    {
                        title: props.localizations.totalTime,
                        field: "",
                        grouping: false,
                        type: "numeric",
                        render: (rowData) => {
                            if (rowData.completedDate && rowData.startedDate) {
                                return (
                                    <>
                                        {parseInt(
                                            moment
                                                .duration(
                                                    moment(rowData.completedDate).diff(moment(rowData.startedDate))
                                                )
                                                .asMinutes() as any
                                        )}{" "}
                                        {props.localizations.min}
                                    </>
                                );
                            } else {
                                return <>-</>;
                            }
                        },
                    },
                ]}
                actions={[
                    {
                        icon: () => (<MenuIcon />) as React.ReactElement<SvgIconProps>,
                        tooltip: props.localizations.actionMenu,
                        onClick: (event, data: CompletedSessionStub) => handleClick(data, event),
                    } as Action<CompletedSessionStub>,
                ]}
                data={completedMentors.map((o) => ({ ...o }))}
            ></MaterialTable>
            <Popover
                id="mouse-over-popover"
                className={classes.popover}
                classes={{
                    paper: classes.paper,
                }}
                open={popOverOpen}
                anchorEl={anchorPopOverEl}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
                onClose={handlePopoverClose}
                disableRestoreFocus
            >
                <Avatar src={hoveredImage} className={classes.large} variant="rounded"></Avatar>
            </Popover>
            <Menu id="tile-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
                <MenuItem
                    onClick={() => {
                        selectOnSight(currentItem);
                    }}
                >
                    <ListItemIcon>
                        <Assistant />
                    </ListItemIcon>
                    <ListItemText>{props.localizations.viewItemDetails}</ListItemText>
                </MenuItem>
            </Menu>
        </Fragment>
        // </div>
    );
}
